import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import DateFormatter from 'common/utils/DateFormatter';
import AddCalendarButton from 'common/components/modules/add-calendar';
import './style.scss'
import ConfirmModal from 'common/components/modules/modal-wrapper';

const UpcomingLiveStream = ({
   date,
   className = 'mx-4 mb-4',
   data = null,
   showAddToCalendar,
}) => {
   return (
      <div
         className={ `rounded-lg flex z-10 sm:items-center px-3 py-4 w-full upcoming-content ${ className } sm:flex-row flex-col` }
      >
         <div className='flex items-center h-full'>
            <div className='h-6 w-6 flex items-center justify-center mr-2'>
               <Icon
                  name='clock'
                  size='lg'
               />

            </div>

            <span className='leading-tight text-major dark:text-major-dark '>
               <span className='font-medium'>Upcoming livestream:</span>&nbsp;{ DateFormatter.getDateByTimzeonFormat(date) }
            </span>

         </div>
         {
            showAddToCalendar && data && (
               <AddCalendarButton
                  title={ data.title }
                  description={ data.description }
                  date={ data.scheduled_livestream_date }
                  className='h-5 w-40 lg:ml-3 mt-2 lg:mt-0 ml-0'
                  buttonState={ {
                     textSize: 'small',
                     fontIconSize: 'small',
                     backgroundColor: 'transparent',
                     classNames: 'truncate h-full',
                  } }
               />
            )
         }
      </div>
   )
}


const AddCalendarModal = ({
   action, 
   closeModal,
   isMobile,
   primaryColor,
}) => {
   return (
      <ConfirmModal
         title='Add event to calendar?'
         type='confirm'
         icon='livestream-calendar'
         primaryColor={ primaryColor }
         description='Would you like to add the scheduled livestream to your calendar app?'
         buttonText='Yes, add to my calendar'
         action={ action }
         cancelButtonAction={ closeModal }
         onCloseModal={ closeModal }
         // isPreventDeafault={ false }
         isMobile={ isMobile }
         confirmButtonProperties={ {
            backgroundColor: '',
         } }
         buttonClassName='w-full mt-8'
      />
   )
}

UpcomingLiveStream.propTypes = {
   date: PropTypes.string,
   className: PropTypes.string,
   data: PropTypes.object,
   showAddToCalendar: PropTypes.bool,
};
AddCalendarModal.propTypes = {
   action: PropTypes.func,
   closeModal: PropTypes.func,
   isMobile: PropTypes.bool,
   primaryColor: PropTypes.string,
};

export  default UpcomingLiveStream
export { AddCalendarModal }
